"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Flex = require("../Flex");

var _Flex2 = _interopRequireDefault(_Flex);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const WrapperBox = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "NavigationItem__WrapperBox",
  componentId: "opabms-0"
})(["border-top:", " ", ";&:hover{background-color:", ";}"], p => p.theme.borders[1], p => p.theme.colors.palette.ink["300"], p => p.theme.colors.palette.ink["000"]);

const NavigationItemBase = (0, _styledComponents2.default)(_Flex2.default).withConfig({
  displayName: "NavigationItem__NavigationItemBase",
  componentId: "opabms-1"
})(["cursor:pointer;height:48px;border-left:", " ", ";color:", ";"], p => p.theme.borders[3], p => p.selected ? p.theme.colors.primary : "transparent", p => p.selected ? p.theme.colors.palette.ink["900"] : p.theme.colors.palette.ink["700"]);

const NavigationItem = (_ref) => {
  let { selected, title } = _ref,
      props = _objectWithoutProperties(_ref, ["selected", "title"]);

  return _react2.default.createElement(
    WrapperBox,
    props,
    _react2.default.createElement(
      NavigationItemBase,
      { alignItems: "center", selected: selected },
      _react2.default.createElement(
        _Text2.default,
        { ml: 3, fontSize: 1 },
        title
      )
    )
  );
};

NavigationItem.propTypes = {};

exports.default = NavigationItem;